module.exports = __webpack_public_path__ + "img/1920_island_intro_img1.23d347cb.png";